/* unplugin-vue-components disabled */import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/rightarrow.png';
var _hoisted_1 = {
  "class": "w-100%"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  "class": "detail"
}, [/*#__PURE__*/_createElementVNode("div", {
  "class": "tag"
}, "智能产品系列"), /*#__PURE__*/_createElementVNode("div", {
  "class": "intro",
  innerHTML: '<span class=color-#225eef>九大</span>智能产品，全面赋能政务呼叫中心'
}), /*#__PURE__*/_createElementVNode("div", {
  "class": "describe"
}, "灵活集成，支持现有系统无缝对接，AI驱动，提升政务服务质量与效率")], -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  "class": "mt-70px"
}, null, -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  "class": "custom-cont-box color-white"
}, [/*#__PURE__*/_createElementVNode("div", {
  "class": "font-size-32px font-600 text-center"
}, "定制化解决方案，满足不同政务场景需求"), /*#__PURE__*/_createElementVNode("div", {
  "class": "font-size-14px text-center mt-6px"
}, " Customized solutions to meet different government scenarios ")], -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  "class": "color-#0150ff"
}, "联系我们，开启政务智能化之旅", -1);
var _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "class": "h-28px"
}, null, -1);
var _hoisted_7 = [_hoisted_5, _hoisted_6];
import customHeader from '@/components/header.vue';
import indexTop from '@/components/indexTop.vue';
import indexProjectShow from '@/components/indexProjectShow.vue';
import customFooter from '@/components/footer.vue';
import indexConnection from '@/components/indexConnection.vue';
import indexBottomCont from '@/components/indexBottomCont.vue';
import indexExample from '@/components/indexExample.vue';
import contactMethod from '@/components/contactMethod.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var contactMethodRef = ref();
    var openModal = function openModal() {
      contactMethodRef.value.open();
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(customHeader, {
        active: 1
      }), _createVNode(indexTop, {
        onShowCode: openModal
      }), _hoisted_2, _createVNode(indexProjectShow, {
        onHandleClick: openModal
      }), _hoisted_3, _createVNode(indexConnection), _createVNode(indexBottomCont), _createVNode(indexExample), _createElementVNode("div", {
        "class": "w-100% min-w-1200px custom-cont"
      }, [_hoisted_4, _createElementVNode("div", {
        "class": "btn font-size-20px",
        onClick: openModal
      }, _hoisted_7)]), _createVNode(customFooter), _createVNode(contactMethod, {
        ref_key: "contactMethodRef",
        ref: contactMethodRef
      }, null, 512)]);
    };
  }
};